import { dbApi, getApiErrorMessage } from "@/lib/api"
import type {
  CompleteEmailVerificationRequest,
  CompleteEmailVerificationResponse,
  EmailVerificationDetails,
} from "@/types/emailVerification"

export async function fetchEmailVerificationDetails(
  token: string
): Promise<
  | { ok: true; details: EmailVerificationDetails }
  | { ok: false; error: string }
> {
  try {
    const { data } = await dbApi.get<EmailVerificationDetails>(
      "/api/auth/register/verify",
      { params: { token } }
    )
    return { ok: true, details: data }
  } catch (e) {
    return { ok: false, error: getApiErrorMessage(e) }
  }
}

export async function completeEmailVerification(
  payload: CompleteEmailVerificationRequest
): Promise<
  | { ok: true; data: CompleteEmailVerificationResponse }
  | { ok: false; error: string }
> {
  try {
    const { data } = await dbApi.post<CompleteEmailVerificationResponse>(
      "/api/auth/register/verify",
      payload
    )
    return { ok: true, data }
  } catch (e) {
    return { ok: false, error: getApiErrorMessage(e) }
  }
}
